import { ordersInProgress, formatMoney } from "@/mocks/managerWorkspace";

export default function OrdersTab() {
  const totalOrders = ordersInProgress.length;
  const totalAmount = ordersInProgress.reduce((sum, o) => sum + o.amount, 0);

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-4">
          <h2 className="text-[14px] font-semibold text-[#2D2D2D] flex items-center gap-2">
            <i className="ri-file-list-2-line text-[15px] text-[#D97706]"></i>
            Заказы
          </h2>
          <span className="text-[11px] text-[#666666]">{totalOrders} заказов на {formatMoney(totalAmount)}</span>
        </div>
        <div className="flex items-center gap-2">
          <button className="flex items-center gap-1 px-2 py-1 text-[11px] text-[#666666] hover:bg-[#FDF2B5] rounded cursor-pointer transition-colors">
            <i className="ri-filter-line text-[11px]"></i>
            Фильтр
          </button>
          <button className="flex items-center gap-1 px-2 py-1 text-[11px] text-[#666666] hover:bg-[#FDF2B5] rounded cursor-pointer transition-colors">
            <i className="ri-add-line text-[11px]"></i>
            Новый заказ
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white border border-[#D5CA8A] rounded overflow-hidden">
        {/* Table header */}
        <div className="grid grid-cols-[70px_1fr_1fr_80px_110px_120px_120px_90px] gap-2 px-3 py-2 bg-[#FFFDF5] border-b border-[#D5CA8A] text-[10px] font-semibold text-[#666666]">
          <span>№</span>
          <span>Клиент</span>
          <span>Товар</span>
          <span>Кол-во</span>
          <span>Сумма</span>
          <span>Статус</span>
          <span>Оплата</span>
          <span>Дата</span>
        </div>

        {/* Table rows */}
        <div className="max-h-[calc(100vh-260px)] overflow-y-auto">
          {ordersInProgress.map((order) => (
            <div
              key={order.id}
              className="grid grid-cols-[70px_1fr_1fr_80px_110px_120px_120px_90px] gap-2 px-3 py-2.5 border-b border-[#E8DB6C]/30 hover:bg-[#FFFDF5] cursor-pointer transition-colors items-center"
            >
              <span className="text-[11px] text-[#666666] font-mono">{order.id}</span>
              <span className="text-[12px] text-[#2D2D2D] font-medium truncate">{order.client}</span>
              <span className="text-[11px] text-[#666666] truncate">{order.product}</span>
              <span className="text-[11px] text-[#2D2D2D]">{order.qty}</span>
              <span className="text-[11px] text-[#2D2D2D] font-semibold">{formatMoney(order.amount)}</span>
              <span>
                <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium ${order.statusColor}`}>
                  {order.status}
                </span>
              </span>
              <span>
                <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-medium ${order.paymentStatusColor}`}>
                  {order.paymentStatus}
                </span>
              </span>
              <span className="text-[10px] text-[#999999]">{order.date}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="flex items-center justify-between mt-3 text-[10px] text-[#666666]">
        <span>Показано: {totalOrders} из {totalOrders}</span>
        <div className="flex items-center gap-1">
          <button className="w-5 h-5 flex items-center justify-center rounded hover:bg-[#FDF2B5] text-[#999999] cursor-pointer">
            <i className="ri-arrow-left-s-line text-[12px]"></i>
          </button>
          <span className="px-1.5 py-0.5 rounded bg-[#FDF2B5] text-[#2D2D2D] font-medium">1</span>
          <button className="w-5 h-5 flex items-center justify-center rounded hover:bg-[#FDF2B5] text-[#999999] cursor-pointer">
            <i className="ri-arrow-right-s-line text-[12px]"></i>
          </button>
        </div>
      </div>
    </div>
  );
}